import { useCallback } from "react";
import { useAxiosInstances } from "../../axios-instance";
import { IUFCount } from "../../../application/states/geo-veles";
import { ICidadeUFCount, ICidadeUFRequest } from "../../../application/models";

export const usePessoaFisicaApi = () => {
  const { axiosAuthInstance } = useAxiosInstances();

  const findUFCountApi = useCallback(async (): Promise<IUFCount> => {
    try {
      const result = await axiosAuthInstance.get("/geo-veles/pessoa-fisica/");
      return result.data;
    } catch (error) {
      throw error;
    }
  }, [axiosAuthInstance]);

  const findCidadeUFCountApi = useCallback(
    async (data: ICidadeUFRequest): Promise<ICidadeUFCount[]> => {
      try {
        const result = await axiosAuthInstance.post(
          "/geo-veles/pessoa-fisica/cidade-uf",
          data,
        );
        return result.data.cidadesUfs || [];
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance],
  );

  return {
    findUFCountApi,
    findCidadeUFCountApi,
  };
};
